<template>
    <div class="area">
        <div class="cond-panel">
            <div class="title">Кто, когда</div>
            <div class="conditions">
                <history-condition-item :data="whoCtrl" placeholder="Сотрудники филиала / конкретный сотрудник" />
                <history-condition-item :data="timeCtrl" placeholder="Дата изменения" />
            </div>
        </div>
        <div class="cond-panel">
            <div class="title">Где, как</div>
            <div class="conditions">
                <history-tab-groups key="id" />
                <div style="padding-left: 22px">
                    <DxButton
                        class="cb-btn"
                        text=""
                        :type="inserted ? 'success' : 'normal'"
                        icon="plus"
                        @click="onClickIns"
                    />
                    <DxButton
                        class="cb-btn"
                        text=""
                        :type="updated ? 'success' : 'normal'"
                        icon="edit"
                        @click="onClickUpd"
                    />
                    <DxButton
                        class="cb-btn"
                        text=""
                        :type="deleted ? 'success' : 'normal'"
                        icon="trash"
                        @click="onClickDel"
                    />
                </div>
            </div>
        </div>
        <div class="cond-panel">
            <div class="title">Контекст</div>
            <div class="conditions">
                <history-condition-item :data="contextCtrl" placeholder="Договор / Объект / Точка учета (контекст)" />
                <div style="padding-left: 22px">
                    <DxButton class="cb-btn" text="Искать" type="default" />
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref, reactive } from 'vue';

import { DxButton } from 'devextreme-vue/button';

import historyConditionItem from '@/views/history/history-card/components/history-condition-item.vue';
import historyTabGroups from '@/views/history/history-card/components/history-tab-groups.vue';

const timeDlgData = reactive({
    isVisible: false,
});

const timeCtrl = reactive({
    value: '2024-01-31',
    placeholderValue: 'Время изменений',
    width: 160,
    onClick: () => {
        console.log(`timeDlgData.isVisible: ${timeDlgData.isVisible}`);
        timeDlgData.isVisible = false;
        return '2022-03-25';
    },
});

const whoCtrl = reactive({
    value: 'Иванов',
    placeholderValue: 'Подразделение или сотрудник',
    width: 764,
    onClick: () => {
        return '2022-03-25';
    },
});

const contextCtrl = reactive({
    value: null,
    placeholderValue: 'Контекст (договор/объект/точка учета)',
    width: 764,
    onClick: () => {
        return null;
    },
});

const inserted = ref(false);
const updated = ref(true);
const deleted = ref(false);

const onClickIns = () => {
    inserted.value = !inserted.value;
};

const onClickUpd = () => {
    updated.value = !updated.value;
};

const onClickDel = () => {
    deleted.value = !deleted.value;
};
</script>

<style>
.cond-panel {
    display: flex;
    align-items: center;
    margin-bottom: 12px;
}

.cond-panel .title {
    padding: 0 0 0 8px;
    font-size: 14px;
    font-weight: 500;
    width: 100px;
}

.cond-panel .conditions {
    display: flex;
    align-items: center;
}

.box-item {
    text-align: center;
    padding-top: 16px;
    font-size: 16px;
    border-bottom: 1px #eee solid;
}

.cb-btn {
    margin-left: 12px;
}

.orange {
    background: #f39e6c;
}

.yellow {
    background: #f5e5a6;
}

.green {
    background: #94d7c7;
}
</style>
